import { useEffect, useState } from 'react';
import axios from 'axios';

export const useBooks = ({ autoLoad = true } = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [books, setBooks] = useState([]);
  const [error, setError] = useState(null);

  const fetchBooks = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await axios.get('/v1/get-books');
      const booksData = response?.data?.result?.data?.books || [];
      
      // Filtra solo i book attivi
      const activeBooks = booksData.filter(book => book.is_active);
      setBooks(activeBooks);
      return activeBooks;
    } catch (err) {
      console.error('Error fetching books:', err);
      setError(err);
      setBooks([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (autoLoad) {
      fetchBooks();
    }
  }, [autoLoad]);

  return {
    isLoading,
    books,
    error,
    fetchBooks,
    setBooks,
  };
};
